import { z } from 'zod';
import { CharacterKindSchema } from './auth.js';

export const OutfitSlotsSchema = z.record(z.string(), z.string().nullable()).or(
  z.object({
    body: z.string().nullable().optional(),
    hat: z.string().nullable().optional(),
    bow: z.string().nullable().optional(),
    glasses: z.string().nullable().optional(),
    collar: z.string().nullable().optional(),
    shoes: z.string().nullable().optional(),
    accessory: z.string().nullable().optional(),
  }),
);

export const SwimSlotsSchema = z.object({
  suit: z.string().nullable().optional(),
  cap: z.string().nullable().optional(),
});

export const OutfitPutRequestSchema = z.object({
  slots: OutfitSlotsSchema,
  swimSlots: SwimSlotsSchema.optional(),
  version: z.number().int().nonnegative(),
});
export type OutfitPutRequest = z.infer<typeof OutfitPutRequestSchema>;

export const OutfitPutResponseSchema = z.object({
  version: z.number().int().nonnegative(),
});
export type OutfitPutResponse = z.infer<typeof OutfitPutResponseSchema>;

export const DogPutRequestSchema = z.object({
  dogName: z.string().min(1).max(24).optional(),
  breed: z.string().min(1).optional(),
  color: z.string().min(1).optional(),
  characterKind: CharacterKindSchema.optional(),
});
export type DogPutRequest = z.infer<typeof DogPutRequestSchema>;

export const DogPutResponseSchema = z.object({
  profile: z.object({
    dogName: z.string(),
    breed: z.string(),
    color: z.string(),
    characterKind: CharacterKindSchema,
  }),
});
export type DogPutResponse = z.infer<typeof DogPutResponseSchema>;

export const SettingsPutRequestSchema = z.object({
  musicOn: z.boolean(),
  sfxOn: z.boolean(),
});
export type SettingsPutRequest = z.infer<typeof SettingsPutRequestSchema>;

export const SettingsPutResponseSchema = z.object({
  ok: z.literal(true),
});
export type SettingsPutResponse = z.infer<typeof SettingsPutResponseSchema>;
